// Mirror of backend/src/lib/templates.ts so the live preview pane renders
// identically to what the server will produce. If the variable list or
// sample values drift between frontend and backend, the preview becomes
// misleading — keep these constants in sync.

export const TEMPLATE_VARS = [
  'actorName',
  'deckTitle',
  'reason',
  'actionUrl',
  'appName',
] as const;
export type TemplateVar = typeof TEMPLATE_VARS[number];

export interface TemplateVars {
  actorName: string;
  deckTitle: string;
  reason: string;
  actionUrl: string;
  appName: string;
}

export const SAMPLE_VARS: TemplateVars = {
  actorName: 'Alex Lee',
  deckTitle: 'Q3 Pipeline Review',
  reason: 'Tighten the data on slide 4 — numbers don\'t match the CRM export.',
  actionUrl: 'https://slides.trackyour.app',
  appName: 'Slide Library',
};

function escapeHtml(s: string): string {
  return s
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}

export function renderTemplate(template: string, vars: TemplateVars): string {
  return template.replace(/\{\{([a-zA-Z][a-zA-Z0-9]*)\}\}/g, (match, name: string) => {
    if ((TEMPLATE_VARS as readonly string[]).includes(name)) {
      const value = vars[name as TemplateVar];
      return value == null ? '' : escapeHtml(String(value));
    }
    return match;
  });
}
